<div mat-dialog-content class="abgang-dialog-content">
    <kiene-gruppe-abgang
        class="abgang-dialog-overview"
        #gruppeAbgang
        [alsDialog]="data?.alsDialog"
        [gruppe]="data?.gruppe"
        [tierliste]="data?.tierliste"
        (geschlossen)="abgangGeschlossen($event)"
        (tiereAnzahlChanged)="onTiereAnzahlChanged($event)"
    >
    </kiene-gruppe-abgang>
</div>

<div mat-dialog-actions *ngIf="data?.alsDialog">
    <button type="button" (click)="close()" mat-button>Abbrechen</button>
    <span class="spacer"></span>
    <button
        type="button"
        (click)="scansFortsetzen()"
        [disabled]="!hasTiereInListe()"
        color="accent"
        mat-flat-button
    >
        Scans fortsetzen
    </button>
</div>
